<ng-container [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label i18n>Roles</mat-label>
    <mat-select id="roles" multiple formControlName="roles">
      @for (option of roleNames; track option) {
        <mat-option [value]="option.id" [title]="option.name">
          {{ option.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-container>
